import type {SketchArcObject} from '../sketch/SketchArcObject';
import {hasRuntimeFlag} from './hasRuntimeFlag';

/**
 * 判断对象是否为草图圆弧对象。
 * @param value 待判断对象。
 * @returns 当对象满足草图圆弧协议时返回 true。
 */
export function isSketchArcObject(value: unknown): value is SketchArcObject {
	// 使用运行时标记判断，兼容跨模块实例场景。
	return hasRuntimeFlag(value, 'isSketchArcObject');
}
